import { createSlice } from '@reduxjs/toolkit';

import { ILoadingState } from './slice.interface';

const initialState: ILoadingState = {
  count: 0,
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    loadingOn: state => {
      state.count += 1;
    },
    loadingOff: state => {
      state.count = state.count < 1 ? 0 : state.count - 1;
    },
  },
});

export const { loadingOff, loadingOn } = loadingSlice.actions;

export default loadingSlice.reducer;
